var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM15.625 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM4.375 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: "currentColor"
  })));
}
export default SvgMoreHorizontal;